<div class="input-container" [ngClass]="{'input-error': isError}">
  <input type="text" class="custom-input" [placeholder]="placeholder">
  <img *ngIf="isError" src="../../../../../assets/icons/dangerous-icon.svg" class="error-icon" />
  <img *ngIf="isMatch" src="../../../../../assets/icons/check_circle-icon.svg" class="match-icon" />
</div>
